import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { MedicationDetail } from "@/modules/patients/detail/medication/components/ch-medication-search"
import { MEDICATION_MODES, MedicationMode } from "@/modules/patients/detail/medication/types/medication-mode"

interface MedicationTemplateSelectionProps {
  medication: MedicationDetail
  handleSearchMedicationText: () => void
  chMedicationMode: MedicationMode
}

const MedicationTemplateSelection = ({
  medication,
  handleSearchMedicationText,
  chMedicationMode,
}: MedicationTemplateSelectionProps) => {
  const { t } = useTranslation()
  const { name, category, productUrl } = medication

  return (
    <div
      className="border-border mb-8 flex justify-between rounded-lg border px-4 py-2"
      data-testid="medication-template-selection">
      <div className="grid items-center">
        <span className="text-on-surface text-base font-medium">{name}</span>
        {category && <span className="text-on-surface-subdued text-xs leading-4 tracking-[0.25px]">{category}</span>}
        {productUrl && (
          <a
            className="text-primary w-fit pt-2 text-sm underline"
            href={productUrl}
            target="_blank"
            rel="noopener noreferrer">
            {t("patient.medication.compendium")}
          </a>
        )}
      </div>
      {chMedicationMode === MEDICATION_MODES.CREATION && (
        <Button variant="secondary" className="w-fit self-end" onClick={handleSearchMedicationText}>
          {t("patient.medication.searchWithAtcCode")}
        </Button>
      )}
    </div>
  )
}

export { MedicationTemplateSelection }
